export default class loginService{

	constructor($http, baseurl){
		this.http = $http;
		this.baseurl = baseurl;
	}

	login(user){
		let url = this.baseurl + '/login';
		let data = {usuario: user.username, clave: user.password}
		return this.http.post(url, data);
	}
}


// WEBPACK FOOTER //
// ./app/js/services/loginService.js